<style scoped>
    .attachment{
        display: inline-block;
        vertical-align: top;
        margin-right: 5px;
        margin-bottom: 5px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        line-height: 1.4;
        cursor: pointer;
    }
    .attachment:hover{
        /*background-color: #e5e5e5;*/
        box-shadow: 0 1px 3px rgba(55,55,55,.3);
    }
    .file-info{
        padding: 5px;
    }
    .filename{
        word-break: break-all;
    }
    .update-time{
        margin-top: 5px;
        color: #959595;
        word-break: break-all;
    }
</style>
<template>
  <div
    class="attachment"
    @click="downloadAttachment"
  >
    <Tooltip
      content="点击下载"
      placement="top"
    >
      <div class="file-info">
        <span class="filename">{{ file.name }}</span>
        <div v-if="showDetail">
          <p
            v-if="file.desc"
            style="margin:5px"
          >
            描述：{{ file.desc }}
          </p>
          <div class="update-time">
            {{ file.account }}: {{ formatTime(file.created_at) }}
          </div>
        </div>
      </div>
    </Tooltip>
  </div>
</template>
<script>
  export default {
    props: {
      file: {
        type: Object
      },
      showDetail: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        //
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      downloadAttachment() {
        return Util.downloadToBlank({
          id:this.file.id
        })
      },
      formatTime(time) {
        return moment(time).format('YYYY-MM-DD HH:mm');
      }
    }
  }
</script>
